import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import StatusBadge from "@/components/StatusBadge";

/** «الأكثر قراءة» — top 5 stories by qualifying article-page reads in the rolling last 24h (server-computed). */
export default function MostRead({ className = "", testId = "most-read" }) {
    const { lang, dir, t } = useLang();
    const [items, setItems] = useState(null);
    useEffect(() => {
        let alive = true;
        const load = () => api.get("/public/most-read", { params: { lang } }).then((r) => { if (alive) setItems(r.data.items || []); }).catch(() => { if (alive) setItems((x) => x || []); });
        load();
        const iv = setInterval(() => { if (document.visibilityState === "visible") load(); }, 5 * 60 * 1000);
        window.addEventListener("articles:removed", load);
        return () => { alive = false; clearInterval(iv); window.removeEventListener("articles:removed", load); };
    }, [lang]);
    if (!items || items.length === 0) return null;   // nothing qualifying → no empty section
    const base = lang !== "ar" ? `/${lang}/article/` : "/article/";
    return (
        <section dir={dir} className={`most-read ${className}`} data-testid={testId} aria-labelledby={`${testId}-title`}>
            <header className="px-4 pt-3.5 pb-3 border-b border-[var(--c-line,#e5e7eb)] flex flex-col items-start gap-2">
                <h3 id={`${testId}-title`} className="font-display font-black text-base leading-none flex items-center gap-2 text-brand-black dark:text-white">
                    <Flame className="w-4 h-4 text-brand-red" aria-hidden /> {t("mostRead")}
                </h3>
                <StatusBadge testId={`${testId}-window`}>{t("last24h")}</StatusBadge>
            </header>
            <ol className="most-read__list" data-testid={`${testId}-list`}>
                {items.map((a, i) => (
                    <li key={a.id} className="most-read__item">
                        <span className="most-read__num" aria-hidden>{i + 1}</span>
                        <Link to={`${base}${a.slug}`} className="most-read__link" data-testid={`${testId}-item-${i + 1}`}>{a.title}</Link>
                    </li>
                ))}
            </ol>
        </section>
    );
}
